import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

const TIMEOUT = 100;

const useScrollRestoration = () => {
  const router = useRouter();
  const scrollPositions = useRef<number[]>([]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.history.scrollRestoration = 'manual';

    const handleRouteChangeStart = () => {
      scrollPositions.current.push(window.scrollY);
    };

    const handleBeforePopState = () => {
      const y = scrollPositions.current.pop() ?? 0;
      setTimeout(() => {
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, TIMEOUT);
      return true;
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);
    router.beforePopState(handleBeforePopState);

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart);
      window.history.scrollRestoration = 'auto';
    };
  }, [router]);
};

export default useScrollRestoration;
